module.exports = __webpack_public_path__ + "img/i12.be8e38ac.svg";